const THEMES = {
  dark: {
    name: 'Midnight Teal',
    header: '#0b1620', hBorder: '#1f2f3b', hText: '#d8f3ef',
    body: '#0a2540', card: '#142131', border: '#22384a',
    text: '#e2ecf7', sub: '#8fa6bc', accent: '#2aa198',
    tHead: '#112032', stripe: '#162739',
    inp: '#18283a', inpB: '#294056', inpT: '#e2ecf7',
    tabA: '#2aa198', tabAT: '#062620',
    cGrid: '#264055',
    loginBg: 'linear-gradient(140deg,#0a2540,#0d3060 42%,#0a2540)',
  },
  light: {
    name: 'Cloud Daylight',
    header: '#ffffff', hBorder: '#d9e2ec', hText: '#10263a',
    body: '#f2f6fb', card: '#ffffff', border: '#d7e1ec',
    text: '#10263a', sub: '#5f7488', accent: '#0f766e',
    tHead: '#eef3f8', stripe: '#f8fbfe',
    inp: '#ffffff', inpB: '#c9d7e4', inpT: '#10263a',
    tabA: '#0f766e', tabAT: '#ecfeff',
    cGrid: '#d7e1ec',
    loginBg: 'linear-gradient(140deg,#f3f7fb,#dfeaf5 48%,#edf4fa)',
  },
  hybrid: {
    name: 'Slate Header + Soft Light',
    header: '#10212f', hBorder: '#223949', hText: '#ddf4f0',
    body: '#f2f6fb', card: '#ffffff', border: '#d7e1ec',
    text: '#10263a', sub: '#5f7488', accent: '#0f766e',
    tHead: '#edf3f8', stripe: '#f8fbfe',
    inp: '#ffffff', inpB: '#c9d7e4', inpT: '#10263a',
    tabA: '#0f766e', tabAT: '#ecfeff',
    cGrid: '#d7e1ec',
    loginBg: 'linear-gradient(140deg,#10212f,#1c3446 46%,#10212f)',
  },
};

export const CHART_COLORS = [
  '#0f766e', '#0ea5a2', '#0369a1', '#dc2626', '#ea580c',
  '#16a34a', '#475569', '#0284c7', '#b45309', '#14532d',
];

export default THEMES;
